                                                                                                                                    //CSS ENTRY POINT
//import '../scss/main.scss';
//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');
window.App = window.App  || {};
window.comApp = window.comApp  || {};
//=====================================
//jquery UI
//=====================================
import 'jquery-ui/ui/widgets/draggable';

//=====================================
//FANCY BOX
//=====================================
// import { Fancybox } from "@fancyapps/ui";
// window.Fancybox = Fancybox;
//=====================================
//Bootstrap
import * as bootstrap from 'bootstrap';
// // Or import only needed plugins
// import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';

// // Or import just one
// import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
//=====================================
// ※Facyboxをインポートすると圧縮版のnpmコンパイルで失敗するため
// webpack.config.jsのwebpack-fix-style-only-entriesを無効にした
//=====================================
// Popper
// require('@popperjs/core');
// require('bootstrap');
// import * as Popper from "@popperjs/core"
//=====================================
// window.Popper = require('@popperjs/core');
//=====================================
//Gsap
//=====================================
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;



//=====================================
//SplitType
//=====================================
// const SplitType = require('split-type').default;
// window.SplitType = SplitType;
//=====================================
//Swiper
// import Swiper JS
// Swiper, Keyboard, Navigation, Pagination, Controller, History, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Lazy, A11y
//=====================================
const Swiper = require('swiper/bundle').default;
const { Navigation, Pagination, Autoplay, EffectFade, Scrollbar } = Swiper;
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Scrollbar]);
window.Swiper = Swiper;

//=====================================
//Muuri
//=====================================
// const Muuri = require('muuri').default;
// window.Muuri = Muuri;

//=====================================
//Swiper Slide 1
//=====================================
window.App.initializeSwiper = function(containerId, menuId, perView) {
  if (typeof perView !== 'number' || isNaN(perView)) {
    console.error('perView must be a number.');
    return;
  }
  var menuSwiper = new Swiper(menuId, {
    slidesPerView: perView,
    spaceBetween: 6,
    allowSlideNext: false,
    allowSlidePrev: false,
  });
  var mainSwiper = new Swiper(containerId, {
    loop: true,
    spaceBetween: 0,
    clickable: true,
    speed: 300,
    thumbs: {
      swiper: menuSwiper,
    },
  });
}

//=====================================
// JQUERY PAGE LOADED
//=====================================

//#37ccb8
//#003b66, #5B97D2
echarts.registerTheme('theme-chart01', {
  backgroundColor: 'transparent', // ラッパーが #005794 前提
  color: ['#ffffff', '#cccccc', '#999999'], // pieグラフなどの自動色
  textStyle: {
    color: '#ffffff'
  },
  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    textStyle: {
      color: '#ffffff'
    }
  },
  axisPointer: {
    lineStyle: {
      color: '#ffffff',
      type: 'dashed'
    }
  },

  // 🔵 Pie チャート向け
  pie: {
    label: {
      color: '#ffffff',
      fontSize: 14,
      lineHeight: 20
    },
    labelLine: {
      lineStyle: {
        color: '#ffffff'
      }
    },  
    itemStyle: {
      borderColor: '#005794',
      borderWidth: 2
    }
  },

  // 📈 Line チャート向け
  line: {
    symbolSize: 8,
    itemStyle: {
      color: '#ffffff'
    },
    lineStyle: {
      color: '#ffffff',
      width: 2
    },
    areaStyle: {
      color: 'rgba(255,255,255,0.2)'
    }
  },

  // 📊 レーダーチャート向け
  radar: {
    axisName: {
      color: '#ffffff',
      fontSize: 12
    },
    axisLine: {
      lineStyle: {
        color: '#ffffff'
      }
    },
    splitLine: {
      lineStyle: {
        color: 'rgba(255,255,255,0.3)'
      }
    },
    splitArea: {
      areaStyle: {
        color: ['transparent']
      }
    }
  },

  // 軸の共通設定（Line系）
  categoryAxis: {
    axisLine: {
      lineStyle: {
        color: '#ffffff'
      }
    },
    axisLabel: {
      color: '#ffffff'
    },
    splitLine: {
      show: false
    }
  },
  valueAxis: {
    axisLine: {
      lineStyle: {
        color: '#ffffff'
      }
    },
    axisLabel: {
      color: '#ffffff'
    },
    splitLine: {
      lineStyle: {
        color: 'rgba(255,255,255,0.2)'
      }
    }
  },
  legend: {
    textStyle: {
      color: '#ffffff'
    }
  }
});








$(function(){

  
//FORMをinput type = telにする
  document.querySelectorAll('input.type_tel').forEach(function(el) {
    el.type = 'tel'; // ←これが確実
  });



/////////////////////////////////////////////
// 〒番号自動補完
//<?php /*https://github.com/ajaxzip3/ajaxzip3.github.io?tab=readme-ov-file*/ ?>
//<script src="https://ajaxzip3.github.io/ajaxzip3.js" charset="UTF-8"></script>
/////////////////////////////////////////////
// $('[name="contact-zip"]').on('keyup', function() {
// console.log("keyup fired");
// AjaxZip3.zip2addr(this, '', 'contact-addr', 'contact-addr');
// });



/////////////////////////////////////////////
//DEV
/////////////////////////////////////////////
$('.draggable').draggable();

  $(".kill").on("click", function() {
    if (confirm("本当に削除しますか？")) {
        $(this).closest(".targetkill").hide();
    }
  });
  


// .bar1要素のアニメーション
// $(".bar1").each(function(index, element) {
//   var width = $(element).width(); // バーの現在の幅を取得
//   var targetWidth = parseInt($(element).css("width")); // 目標の幅を取得
//   $(element).css("width", "0px");
//   gsap.to(element, {
//     scrollTrigger: {
//       trigger: element,
//       start: "top 80%", 
//       end: "bottom 20%",
//     },
//     width: targetWidth + "px",
//     duration: .5,
//     ease: "power2.inOut", 
//   });
// });

// $(".bar2").each(function(index, element) {
//   var height = $(element).height(); 
//   var targetHeight = parseInt($(element).css("height")); 
//   $(element).css("height", "0px");
//   gsap.to(element, {
//     scrollTrigger: {
//       trigger: element, 
//       start: "top 80%", 
//       end: "bottom 20%",
//     },
//     height: targetHeight + "px",
//     duration: .5,
//     ease: "power2.inOut", 
//   });
// });






//////////////////////////////
//カウントアップ
//////////////////////////////
$(".txt-num > i").each(function(index, element) {
  var $target = $(element);
  var targetText = $target.text();
  var targetNumber = parseInt(targetText, 10);
  var paddingLength = targetText.length; // 元の文字列の桁数を保持

  var duration = 800; // アニメーションの継続時間（ミリ秒）
  var currentNumber = 0; // 現在の数字

  function animateNumber() {
    $({ countNum: currentNumber }).animate({ countNum: targetNumber }, {
      duration: duration,
      easing: 'linear',
      step: function() {
        var value = Math.floor(this.countNum).toString().padStart(paddingLength, '0');
        $target.text(value);
        $target.addClass('animating').removeClass("animating_done"); 
      },
      complete: function() {
        var finalValue = targetNumber.toString().padStart(paddingLength, '0');
        $target.text(finalValue);
        $target.removeClass('animating').addClass("animating_done");
      }
    });
  }

  // カウントアップのアニメーションをスクロールトリガーとして設定
  gsap.to({}, {
    duration: 0.01,
    scrollTrigger: {
      trigger: $target.parent(), // 親要素をトリガーにする
      start: "top 80%", // スクロール位置でトリガー
      onEnter: animateNumber, // 要素がビューポートに入ったときにアニメーションを開始
      // markers: true // マーカーを表示（デバッグ用）
    }
  });
});




/* ==================
SCROLL HEADER HEIGHT
===================== */
var headerH = $("#header").outerHeight(true); // headerの高さを取得
  function toggleHeaderClass() {
    $('body').toggleClass('is_scrollstart', $(window).scrollTop() >= headerH);
  }
  // 画面をスクロールしたら動かす
  $(window).scroll(toggleHeaderClass);
  // ページが読み込まれたらすぐに動かす
  $(window).on('load', toggleHeaderClass);


  var isScrolling = false;
  var timeoutId;
  function addScrollStopClass() {
    $("body").addClass("is_scrolling");
  }
  function removeScrollStopClass() {
    $("body").removeClass("is_scrolling");
  }
  window.addEventListener("scroll", function() {
    clearTimeout(timeoutId);
    removeScrollStopClass();
    timeoutId = setTimeout(function() {
      addScrollStopClass();
    }, 300);
  });
  $(window).on("scroll", function() {
    clearTimeout(timeoutId);
    addScrollStopClass();
    timeoutId = setTimeout(function() {
      removeScrollStopClass();
    }, 300);
  });







///////////////////////////////
// SLIDE-DOWN
///////////////////////////////
$(".item-slidedown dt").on("click", function(e) {
  e.preventDefault(); // デフォルト動作を防ぐ

  var parent = $(this).closest(".item-slidedown");
  var answer = parent.find("dd");
  var isOpen = parent.attr("aria-expanded") === "true";

  if (isOpen) {
    parent.attr("aria-expanded", "false");
    answer.slideUp(300);
  } else {
    parent.attr("aria-expanded", "true");
    answer.slideDown(300);
  }
});

// dd 内をクリックしても親要素のイベントを発火させない
$(".item-slidedown dd").on("click", function(e) {
  e.stopPropagation();
});

///////////////////////////////
// SWITCH BUTTON OPEN ALL
///////////////////////////////
$(".toggle").on("click", function() {
  $(this).toggleClass("checked");
  var isChecked = !$(this).find('input[name="check"]').prop("checked");
  $(this).find("input").prop("checked", isChecked);

  // data-target の取得
  var targetSection = $(this).attr("data-target");

  // 該当の section 内の dt 要素を操作
  $("#" + targetSection).find("dt").each(function() {

      if (isChecked) {
          $(this).parent('dl').attr("aria-expanded", "true");
          $(this).next("dd").slideDown(300);
      } else {
          $(this).parent('dl').attr("aria-expanded", "false");
          $(this).next("dd").slideUp(300);
      }
  });
});


















//RESIZE用イベント（Swiper,muuri用）
// function triggerResizeEvent() {
//   var event = document.createEvent('Event');
//   event.initEvent('resize', true, true);
//   window.dispatchEvent(event);
// }

/* ==================
SIDE MENU
===================== */
$('#glb_side_menu').on({
  'mouseenter': function() {
    $('body').addClass('is-sidemenu-hover');
  },
  'mouseleave': function() {
    $('body').removeClass('is-sidemenu-hover');
  }
});
var menuVisible = false; 
var fixedVisible = false;
$('#glb_side_menu').on('click', function() {
  if (!menuVisible && !fixedVisible) { 
      $('body').addClass('is_side_menu');
      menuVisible = true; 
  }
});
$('#wrapper-contents').on('mouseenter mouseover click touchend', function(e) {
  $('body').removeClass('is_side_menu');
  menuVisible = false; 
});
// $('#btn_side_fixed').on('click touchend', function() {
//   if (!fixedVisible) { 
//     $('body').addClass('is_side_menu_fixed is_side_menu');
//     $('#btn_side_fixed').addClass('active');
//     fixedVisible = true;
//     menuVisible = false;
//     triggerResizeEvent();
//   }else{
//     $('body').removeClass('is_side_menu_fixed is_side_menu');
//     $('#btn_side_fixed').removeClass('active');
//     fixedVisible = false;
//     triggerResizeEvent();
//   }
// });
$('#global_burgermenu').on('click', function() {
  if (!menuVisible) { 
    $('body').addClass('is_side_menu');
  menuVisible = true; 
  // triggerResizeEvent();
  }else{
    $('body').removeClass('is_side_menu_fixed is_side_menu');
    menuVisible = false;
    // triggerResizeEvent();
  }
});



/////////////////////////////////////////////
//MODAL 外部から呼び出すため
/////////////////////////////////////////////
window.comApp.loadSection = function(source, modalId, modalTitle) {
  if (source.startsWith('#')) {
      // Copy content from the specified element
      var content = $(source).html();
      $("#ajx_content_output").html(content);
      $(modalId).find('.modal-title').html(modalTitle);
      $(modalId).modal('show');
  } else {
      // Load content from the specified URL
      $.ajax({
          type: 'GET',
          url: source,
          success: function(data) {
              $("#ajx_content_output").html(data);
              $(modalId).find('.modal-title').html(modalTitle);
              $(modalId).modal('show');
          }
      });
  }
};

/* ==================
SCROLL HEADER HEIGHT
===================== */
// var headerH = $("#header").outerHeight(true); // headerの高さを取得
//   function toggleHeaderClass() {
//     $('body').toggleClass('is_scrollstart', $(window).scrollTop() >= headerH);
//   }
//   // 画面をスクロールしたら動かす
//   $(window).scroll(toggleHeaderClass);
//   // ページが読み込まれたらすぐに動かす
//   $(window).on('load', toggleHeaderClass);


///////////////////////
//AJAX ZIP
// イベントハンドラを定義
///////////////////////
// function handleAjaxZip3() {
// AjaxZip3.zip2addr('postal_code1', '', 'prefectures', 'address1');

// // 成功時に実行する処理
// AjaxZip3.onSuccess = function() {
//     //  // 正しいIDを指定する必要があります
//     // $('textarea[name="content"]').val('');
// };

// // 失敗時に実行する処理
// AjaxZip3.onFailure = function() {
//     alert('郵便番号に該当する住所が見つかりません');
//     $('input[name="prefectures"]').val('');
//     $('input[name="address1"]').val('');
//     $('input[name="address2"]').val('');
// };
// }
// // クリックイベントに対する処理
// $('.ajaxzip3').on('click', function() {
//   handleAjaxZip3();
//   return false;
// });

// // Keyupイベントに対する処理
// $('#postal_code1').on('keyup', function() {
//   handleAjaxZip3();
// });

///////////////////////////////
/// TEXTAREA AUTOHEIGHT
/////////////////////////////////
$('.js-autoheight').on('input', function(){
  this.style.height = 'auto';
  this.style.height = (this.scrollHeight) + 'px';
});
// ////////////////////////
// //FORM COPY
// ////////////////////////
// // モーダルが開かれる瞬間に発生するイベント
// $('#Modal-form00').on('show.bs.modal', function () {

//   $('body').removeClass('is_side_menu');
//   var formAContent = $('#formA .fm-contact00').clone(true);
//   $('#formB').empty().append(formAContent);
//   $('#formA').empty();

//   // $(document).on('click', '.submit-ajax', function() {
//   //     alert("dd");
//   // });
// });
// // モーダルが閉じられる瞬間に発生するイベント
// $('#Modal-form00').on('hidden.bs.modal', function () {
//   var formBContent = $('#formB .fm-contact00').clone(true);
//   $('#formA').empty().append(formBContent);
//   $('#formB').empty();
// });
/////////////////////////
///AKAX POST
//////////////////////////


// $(document).on('click', '.submit-ajax', function(event) {
//    // ◎ボタンを無効化
//   $(this).prop('disabled', true);
//   $(this).find("span").html('処理中...');

//   var $myform = $(this).closest("form");
//   var form_id = $myform.attr("id");
//   var formToken = $myform.find('input[name="formToken"]').val()
//   $.ajax({
//     url: '/contact.php',
//     type: 'post',
//     data: $myform.serialize(),
//     dataType: 'json',
//     success: function(response) {
//         $(".error").empty();
//         console.log(response);

//         // ◎ボタンを有効化
//         $('.submit-ajax').prop('disabled', false);
//         $('.submit-ajax').find("span").html('送信する'); // 元のボタンのテキストに戻す

//         if (response.errors) {
//             var errors = response.errors;

//             // 最初に表示されたエラーのIDにスクロール
//             if (Object.keys(errors).length > 0) {
//                 var firstErrorKey = Object.keys(errors)[0];
//                 var firstErrorElement = $('#' + form_id + ' #error_' + firstErrorKey);  

//                 // エラーが非表示の場合、表示する
//                 firstErrorElement.show();

//                 // モーダル内であればモーダルのスクロール対象要素までスクロール
//                 if ($myform.find('.modal').length > 0) {
//                     $('#' + form_id + ' .modal-body').animate({
//                         scrollTop: firstErrorElement.offset().top - $('#' + form_id + ' .modal-body').offset().top + $('#' + form_id + ' .modal-body').scrollTop() - $('#' + form_id + ' .modal-header').height()
//                     }, 500);
//                 } else {
//                     // モーダル内でなければ通常のスクロール
//                     var scrollOffset = firstErrorElement.offset().top - $(document).scrollTop() - 80;
//                     $('html, body').animate({
//                         scrollTop: '+=' + scrollOffset + 'px'
//                     }, 500);
//                 }
//             }
//             for (var key in errors) {
//                 var errorSelector = '#error_' + key;
//                 $(errorSelector).html(errors[key]);
//                 console.log(errorSelector + "です");
//             }
//         } else if (response.success) {
//           var redirectUrl = '/contact_done.php';
//           var postData = {
//               referrer: encodeURIComponent(window.location.href),
//               token: formToken
//           };

//           // Create a hidden form dynamically
//           var hiddenForm = $('<form>', {
//               action: redirectUrl,
//               method: 'post',
//               style: 'display:none;'
//           });

//           // Add the necessary inputs (referrer and token)
//           for (var key in postData) {
//               hiddenForm.append($('<input>', {
//                   type: 'hidden',
//                   name: key,
//                   value: postData[key]
//               }));
//           }

//           // Append the form to the body and submit it
//           $('body').append(hiddenForm);
//           hiddenForm.submit();
//           }
//     },
//     error: function(error) {

//         // ◎エラー時もボタンを有効化
//         $('.submit-ajax').prop('disabled', false);
//         $('.submit-ajax').find("span").html('送信する'); // 元のボタンのテキストに戻す

//         console.log('Error:', error);
//     }
// });





// /////////////////////////////////////////////
// //DEV TARGET KILL
// /////////////////////////////////////////////








// });


/////////////////////////////////////////////
//TOOL TIPS (no HOVER but CLICK)
/////////////////////////////////////////////
// $('[data-bs-toggle="tooltip"]').tooltip();


/////////////////////////////////////////////
//DEV
/////////////////////////////////////////////
// $(".dev-bg i").on("click", function(e) {
//   e.preventDefault();
//   var classNum = $(this).data("bg");
//   $(this).closest(".mvimg").removeClass(function(index, className) {
//   return (className.match(/(^|\s)mv-\S+/g) || []).join(" ");
//   }).addClass("mv-" + classNum);
//   });
  
//   $('[data-js="add_hover"]').hover(function() {
//   $(this).closest('.mvimg').addClass('is_hover');
//   }, function() {
//   $(this).closest('.mvimg').removeClass('is_hover');
//   });



$('[data-js="add_hover"]').hover(function() {
$(this).closest('.mvimg').addClass('is_hover');
}, function() {
$(this).closest('.mvimg').removeClass('is_hover');
});















///////////////////////////////////////////////////////
//contact form
///////////////////////////////////////////////////////


    $(".fm-table").each(function(){
        var $fmTable = $(this);
        var $fieldset = $fmTable.find(".hidden");
        var $button = $fmTable.find(".fm-btn-slidedown");

        var hasInput = $fieldset.find("input[type='text'], input[type='password'], input[type='email'], input[type='number'], textarea, select").filter(function() {
            return $(this).val().trim().length > 0;
        }).length > 0;
        var hasChecked = $fieldset.find("input[type='checkbox']:checked, input[type='radio']:checked").length > 0;
        var hasError = $fieldset.find(".errort").length > 0;

        // 入力済み or エラーがある場合、表示
        if (hasInput || hasChecked || hasError) {
            $fieldset.show();
            $button.addClass("is_active"); // 初期表示時にクラス追加
        }

        // ボタンを押したら開閉 & クラスのトグル
        $button.on("click", function(){
            $fieldset.slideToggle();
            $(this).toggleClass("is_active"); // is_active クラスの追加・削除
        });
    });



















/////////////////////////////////////////////
//MARQUEE #TEST 
/////////////////////////////////////////////
class Marquee {
  constructor() {
    this.els = document.querySelectorAll('.marquee');
    if (!this.els) return;
    this.init();
  }

  init() {
    this.els.forEach(el => {
      if (getComputedStyle(el).display === 'none') return;

      const options = {
        speed: el.dataset.marqueeSpeed || 60,
        direction: el.dataset.marqueeDirection || 'left',
        pauseOnHover: el.dataset.marqueeHover === 'true'
      };
      this.Marquee(el, options);
    });
  }

  Marquee(el, options) {
    const { speed, direction, pauseOnHover } = options;
    const wrapper = el.querySelector('.marquee-wrapper');
    const content = el.querySelector('.marquee-content');

    this.appendContent(content, wrapper);
    this.updateWrapperWidth(content, wrapper);
    let animation = this.Animation(wrapper, speed, direction);
    this.touchEvent(el, animation, wrapper, speed, direction);
    this.hoverEvent(el, animation, pauseOnHover);
    this.observerEvent(el, animation);
  }

  updateWrapperWidth(content, wrap) {
    const contentWidth = content.getBoundingClientRect().width;
    if (contentWidth === 0) return;
    const gap = parseInt(getComputedStyle(content).columnGap) || 0;
    wrap.style.width = `${contentWidth + gap}px`;
  }

  appendContent(content, wrap) {
    const innerWidth = window.innerWidth;
    const contentWidth = content.getBoundingClientRect().width;

    // 後方に必要数のクローン
    const count = Math.ceil(innerWidth / contentWidth) + 2;
    for (let i = 0; i < count; i++) {
      const clone = content.cloneNode(true);
      wrap.appendChild(clone);
    }

    // 前方にも最低2個クローン
    for (let i = 0; i < 2; i++) {
      const cloneBefore = content.cloneNode(true);
      wrap.insertBefore(cloneBefore, wrap.firstChild);
    }
  }

  Animation(wrap, speed, direction) {
    const wrapWidth = wrap.getBoundingClientRect().width;
    if (wrapWidth === 0) return;

    const keyframes = direction === 'left'
      ? [{ transform: 'translateX(0)' }, { transform: `translateX(-100%)` }]
      : [{ transform: 'translateX(-100%)' }, { transform: `translateX(0)` }];

    const options = {
      duration: (wrapWidth / speed) * 1000,
      iterations: Infinity
    };

    return wrap.animate(keyframes, options);
  }

  hoverEvent(el, animation, hasOpt) {
    if (!hasOpt) return;
    el.addEventListener('mouseenter', () => animation.pause());
    el.addEventListener('mouseleave', () => animation.play());
  }

  observerEvent(el, animation) {
    const observerOptions = { root: null, threshold: 0 };
    const observer = new IntersectionObserver(entries => {
      entries[0].isIntersecting ? animation.play() : animation.pause();
    }, observerOptions);

    observer.observe(el);
  }

  touchEvent(el, animation, wrapper, speed, direction) {
    let isDown = false;
    let startX = 0;
    let lastX = 0;
    let velocity = 0;
    let translateX = 0;
    let lastMoveTime = 0;
    let animationFrameId = null;

    const getTranslateX = () => {
      const style = window.getComputedStyle(wrapper);
      const matrix = new DOMMatrixReadOnly(style.transform);
      return matrix.m41 || 0;
    };

    const normalizeTranslateX = () => {
      const wrapWidth = wrapper.getBoundingClientRect().width;
      // wrapWidthの2倍ぐらい超えたら補正
      if (translateX < -wrapWidth) {
        translateX = translateX % wrapWidth;
      } else if (translateX > 0) {
        translateX = -wrapWidth + (translateX % wrapWidth);
      }
    };

    const restartAnimation = (fromX) => {
      const wrapWidth = wrapper.getBoundingClientRect().width;
      let normalizedX = fromX % wrapWidth;

      const keyframes = direction === 'left'
        ? [
            { transform: `translateX(${normalizedX}px)` },
            { transform: `translateX(${normalizedX - wrapWidth}px)` }
          ]
        : [
            { transform: `translateX(${normalizedX}px)` },
            { transform: `translateX(${normalizedX + wrapWidth}px)` }
          ];

      const duration = (wrapWidth / speed) * 1000;

      return wrapper.animate(keyframes, {
        duration,
        iterations: Infinity,
        fill: 'forwards'
      });
    };

    const applyInertia = () => {
      cancelAnimationFrame(animationFrameId);
      const friction = 0.95;
      const step = () => {
        velocity *= friction;
        translateX += velocity;
        normalizeTranslateX();
        wrapper.style.transform = `translateX(${translateX}px)`;

        if (Math.abs(velocity) > 0.5) {
          animationFrameId = requestAnimationFrame(step);
        } else {
          animation = restartAnimation(translateX);
        }
      };
      step();
    };

    if ('ontouchstart' in window) {
      wrapper.addEventListener('touchstart', (e) => {
        cancelAnimationFrame(animationFrameId);
        isDown = true;
        startX = e.touches[0].pageX;
        lastX = startX;
        translateX = getTranslateX();
        wrapper.style.transition = 'none';
        lastMoveTime = Date.now();
        animation.cancel(); // 一時停止
      });

      wrapper.addEventListener('touchmove', (e) => {
        if (!isDown) return;

        const now = Date.now();
        const currentX = e.touches[0].pageX;
        const deltaX = currentX - lastX;

        velocity = deltaX / (now - lastMoveTime) * 16; // フレームあたりの速度
        translateX += deltaX;
        normalizeTranslateX();
        wrapper.style.transform = `translateX(${translateX}px)`;

        lastX = currentX;
        lastMoveTime = now;
      });

      wrapper.addEventListener('touchend', () => {
        isDown = false;
        applyInertia();
      });
    }
  }
}

const marquee = new Marquee();






///////////////////////////////////////////////////////
//タイマー
///////////////////////////////////////////////////////

// const clock = () => {
//   // 現在の日時・時刻の情報を取得
//   const d = new Date();

//   // 年を取得
//   let year = d.getFullYear();
//   // 月を取得
//   let month = d.getMonth() + 1;
//   // 日を取得
//   let date = d.getDate();
//   // 曜日を取得
//   let dayNum = d.getDay();
//   const weekday = ["日", "月", "火", "水", "木", "金", "土"];
//   let day = weekday[dayNum];
//   // 時を取得
//   let hour = d.getHours();
//   // 分を取得
//   let min = d.getMinutes();
//   // 秒を取得
//   let sec = d.getSeconds();
//   let today = `${month}月${date}日`;
//   let week = `${day}`;
//   let time = `${hour}時${min}分`;

//   // 文字列を出力
//   document.querySelector(".clock-date").innerText = today;
//   // document.querySelector(".clock-week").innerText = week;
//   document.querySelector(".clock-time").innerText = time;
// // 昼夜のクラスを切り替え
// const body = document.body;
// if (hour >= 6 && hour < 18) {
//   body.classList.add('js-mode-day');
//   body.classList.remove('js-mode-night');
// } else {
//   body.classList.add('js-mode-night');
//   body.classList.remove('js-mode-day');
// }
// };
// // 1秒ごとにclock関数を呼び出す
// if($('.clock').length) {
//   setInterval(clock, 1000);
//   }
// })
// var countElm = $('.count'),
// countSpeed = 1;
// countElm.each(function(){
//   var self = $(this),
//   countMax = self.attr('data-num'),
//   thisCount = self.text(),
//   countTimer;

//   function timer(){
//     countTimer = setInterval(function(){
//       var countNext = thisCount++ / 10;

//       if(countNext.toString().match(/^-?[0-9]+\.[0-9]+$/)){
//         self.text(countNext);
//       } else {
//         self.text(countNext + '.0');
//       }

//       if(countNext == countMax){
//         clearInterval(countTimer);
//       }
//     },countSpeed);
//   }
//   timer();
});






















/* ==================
SP BUGER MENU
===================== */
// $('#global_burgermenu > button').on('click', function() {
//   $(this).toggleClass('active');
//   if($(this).hasClass('active')){
//       $('body').addClass('is-sp-menu').removeClass('is-sp-menu-close');
//   }else{
//       $('body').removeClass('is-sp-menu').addClass('is-sp-menu-close');
//       $('#global-sp-menu').one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function() {
//         $('body').removeClass('is-sp-menu-close');
//       });
//     }
// });

// const popover = new bootstrap.Popover('.popover-dismiss', {
//   trigger: 'focus'
// })
// $('[data-fancybox="gallery"]').fancybox({});
// $('[data-fancybox="gallery"]').fancybox({
//   // 任意の設定を追加
// });

/////////////////////////////////////
/// SIDEBAR表示トリガー
/////////////////////////////////////
// $('.sidebar-toggle').on('click', function() {
//   $('body').toggleClass('is-sidemenu');
// })
// $(document).on("click", function(event) {
//   if (!$(event.target).closest("#sidebar").length && !$(event.target).is(".sidebar-toggle")) {
//     $('body').removeClass('is-sidemenu');
//   }
// });
//////////////////////
//スクロース中はSIDE NAVを隠す挙動
//////////////////////
// var timeoutId;
// window.addEventListener("scroll", function() {
//     clearTimeout(timeoutId);
//     $("#side-nav").toggleClass("is_scrollstop", $(window).scrollTop() >= 200);
//     timeoutId = setTimeout(function() {
//         // スクロール停止後の処理
//         // ここに何か追加する場合はここに記述
//     }, 300);
// });
// 別の要素をクリックで閉じる
// $(document).on('click touchend', function(e) {
//     if (!$(e.target).closest('#nav-content').length) {
//         $("#side-nav").removeClass("is_slidein"); // 修正
//     }
// });


/* ==================
SP BUGER MENU
===================== */
// $('.btn-jsopen-modal-form').on('click', function() {
//   $('body').addClass('is-modal-form00').removeClass('is-sp-menu-close');
//   $('#Modal-form00').one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd',
//    function() {
//     // $('body').removeClass('is-sp-menu').addClass('is-sp-menu-close');
//     // $('body').removeClass('is-sp-menu-close');
//   });
// });


// click: マウスの左ボタンで要素がクリックされたとき。
// dblclick: マウスの左ボタンで要素がダブルクリックされたとき。
// mousedown: マウスのボタンが要素上で押されたとき。
// mouseup: マウスのボタンが要素上で離されたとき。
// mousemove: マウスが要素上で移動したとき。
// Touch Events (タッチイベント):

// touchstart: タッチが画面上で始まったとき。
// touchmove: タッチが画面上で移動したとき。
// touchend: タッチが画面上で終わったとき。
// touchcancel: タッチがキャンセルされたとき。
// Keyboard Events (キーボードイベント):

// keydown: キーが押されたとき。
// keyup: キーが離されたとき。
// keypress: 文字が入力されたとき。
// Focus Events (フォーカスイベント):

// focus: 要素がフォーカスを受け取ったとき。
// blur: 要素がフォーカスを失ったとき。
// Window Events (ウィンドウイベント):

// resize: ウィンドウのサイズが変更されたとき。
// scroll: ページがスクロールされたとき。


//////////////////////////////////////////////
  // var originalClasses = {}; // オリジナルのクラスを保持する連想配列
  // // ページ読み込み時に.dev-bgの数を調べ、originalClassesを初期化
  // $(".dev-bg").each(function(index) {
  //   var mvimgElement = $(this).closest(".mvimg");
  //   var originalClass = mvimgElement.attr("class").match(/mv-\d+/)[0]; // mv-(number)のクラスを取得

  //   // idがない場合は"DEV_{originalClass}"の名前のIDを付与
  //   var sectionId = mvimgElement.attr("id") || `DEV_${originalClass}`;
  //   mvimgElement.attr("id", sectionId); // IDを付与

  //   var classNum = $(this).find("i").data("bg"); // 子要素のiからdata-bgの値を取得
  //   var originalClassLastDigits = originalClass.slice(-3); // originalClassの下3桁の数字を取得
  //   $(this).closest(".mvimg").find("i[data-bg=" + originalClassLastDigits + "]").addClass("bg-selected");//originalClassででもいい
 
  //   originalClasses[sectionId] = originalClass;
  // });
  
  // $(".dev-bg i").on("mouseenter mouseleave click", function(e) {
  //   e.preventDefault();
  //   var sectionId = $(this).closest(".mvimg").attr("id"); // .mvimgのidを取得
  //   var originalClass = originalClasses[sectionId];
  //   var classNum = $(this).data("bg");
  //   var mvimg = $(this).closest(".mvimg");
  
  //   // すべてのmv-(number)クラスを削除
  //   mvimg.removeClass(function(index, className) {
  //     return (className.match(/(^|\s)mv-\S+/g) || []).join(" ");
  //   });
  
  //   if (e.type === "mouseenter" || (e.type === "click" && !$(this).hasClass("active"))) {
  //     // 他のmv-(number)クラスを削除してから追加
  //     mvimg.addClass("mv-" + classNum);
  //   }
  
  //   if (e.type === "click") {
  //     // click イベントが発生したときに active クラスを付与
  //     $(this).addClass("active");
  //     originalClasses[sectionId] = "mv-" + classNum;
  //   } else if (e.type === "mouseleave" && !$(this).hasClass("active")) {
  //     // click イベントが発生していない場合のみ originalClass を親に追加
  //     mvimg.addClass(originalClass);
  //   }
  
  //   console.log(originalClasses); // originalClassesの値をコンソールに出力
  // });

// $('#modal_content').off('show.bs.modal').off('hide.bs.modal');
// $('#modal_content').on('show.bs.modal', function () {
//   gsap.fromTo('.modal', {x: '200%'}, {x: '0%', duration: 0.5, ease: 'power4.out'});
// });

// $('#modal_content').on('hide.bs.modal', function () {
//   gsap.to('.modal', {x: '200%', duration: 0.5, ease: 'power4.in'});
// });

/////////////////////////////////
    /*画像パララックス*/
/////////////////////////////////
//TOP PAGE MV
    // gsap.from("#an-tit1", {
    //   x:-100,
    //   opacity: 1,
    //   ease: "power2.out",
    // });

    // gsap.set('.mv-txt00', {
    //   x: -300,
    //   y: 0,
    //   scale: 0,
    //   opacity: 0,
    // });
  ///////////////////////////////////////////////////////
    // var initialAnimationComplete = false;
    // // GSAP Animation
    // var animation = gsap.fromTo('.mv-txt00', {
    //   x: -300,
    //   y: 0,
    //   scale: 0,
    //   opacity: 0,
    // }, {
    //   x: 0,
    //   y: 0,
    //   scale: 1,
    //   opacity: 1,
    //   duration: .5,
    //   // paused: true // アニメーションを最初は一時停止
    // });


    
    // // Click event to trigger animation
    // $('#btn-mv-slide1').on("click",function() {
    //   // ボタンがクリックされたときにアニメーションを再生
    //   animation.play();
    // });

    // // ページがロードされたときの処理
    // $(document).ready(function() {
    //   // 初回のみアニメーションを再生
    //   if (!initialAnimationComplete) {
    //     animation.play();
    //     initialAnimationComplete = true;
    //   }
    // });
  ///////////////////////////////////////////////////////
  //   gsap.fromTo("#an-tit2", .5,
  //   {
  //     x: -100,
  //     y: 0,
  //     scale:0,
  //     opacity: 0,
  //   },
  //   // x, y 100px移動した状態で終了
  //   {
  //     x: 0,
  //     y: 0,
  //     scale:1,
  //     opacity: 1,
  //   }
  // )

    // gsap.from("#an-stit", {
    //   x:-1000,
    //   y: -1000,
    //   rotation: -240,
    //   opacity: 0,
    //   delay: 2,
    //   duration: 1,
    //   scale:10,
    //   ease: "power2.out",
    // });

    // gsap.from("#char2 .char", {
    //   y:-500,
    //   x:-500,
    //   scale:0,
    //   rotation: 180,
    //   stagger: .05,
    //   opacity: 0,
    //   delay: 2.2,
    //   duration: 0.6,
    //   ease: "power2.out",
    // });


    // // 各要素に対してアニメーションを設定
    // lines.forEach((line, index) => {
    //   // ScrollTriggerを使ってアニメーションを設定
    //   gsap.to(line, {
    //     width: '100%', // 線の長さ
    //     duration: 0.5, // アニメーション時間
    //     scrollTrigger: {
    //       trigger: '#section-cominfo',
    //       start: 'top center+=100', // トリガーの開始位置
    //       end: 'top center+=200', // トリガーの終了位置
    //       // markers: true, // マーカーを表示（デバッグ用）
    //       // onEnter: () => console.log('enter'), // トリガーに入ったときの処理
    //       // onEnterBack: () => console.log('enter back'), // トリガーに戻ったときの処理
    //     }
    //   });
    // });

/* ==================
SCROLL POSITION 
===================== */
// gsap.registerPlugin(ScrollTrigger);
// var navLinks = document.querySelectorAll('#glb_side_menu nav a');
// navLinks.forEach(function(link) {
//     var targetHref = link.getAttribute('href');
//     var sectionId = getHashFromUrl(targetHref);
//     var targetSection = document.getElementById(sectionId);
//     if (targetSection) {
//         gsap.to(targetSection, {
//             scrollTrigger: {
//                 trigger: targetSection,
//                 start: 'top center',
//                 end: 'bottom center',
//                 onToggle: function(self) {
//                     // スクロールが発生したときにクラスを切り替える
//                     link.closest('.pc_m').classList.toggle('js-this-position', self.isActive);
//                 },
//                 // markers: true // Optional: For debug purposes, you can enable markers
//             }
//         });
//     }
// });
/* ==================
SCROLL 
===================== */

// function scrollToTarget(target) {
//   gsap.to(window, {
//       scrollTo: { y: target, autoKill: false },
//       duration: 0.5, // 適切なドゥレーションを設定
//       ease: "power2.inOut", // 適切なイージングを設定
//       onComplete: function() {
//           // アニメーション終了後に最終的なスクロール位置に調整
//           window.scrollTo(0, target);
//       },
//   });
// }

// function getHashFromUrl(url) {
//     var hashIndex = url.lastIndexOf('#');
//     if (hashIndex !== -1) {
//         return url.substring(hashIndex + 1);
//     }
//     return '';
// }

// function scrollToTarget(target) {
//     gsap.to(window, {
//         scrollTo: { y: target, autoKill: false },
//         duration: 0,
//         ease: "power2.in",
//     });
// }

// // ページ読み込み時にハッシュがあればスクロール
// window.onload = function() {
//     if (window.location.hash) {
//         var targetId = window.location.hash.substring(1); // # を取り除く
//         var target = document.getElementById(targetId);
//         if (target) {
//             scrollToTarget(target.offsetTop);
//         }
//     }
// };

// // #で始まるアンカーリンクがクリックされたときにスクロール
// document.querySelectorAll('a[href^="#"]').forEach(function(link) {
//     link.addEventListener('click', function(e) {
//         e.preventDefault();
//         var targetId = link.getAttribute('href').substring(1); // # を取り除く
//         var target = document.getElementById(targetId);
//         if (target) {
//             scrollToTarget(target.offsetTop);
//         }
//     });
// });



/////////////////////////////////////////////
//言語判定
/////////////////////////////////////////////
// ブラウザの言語を取得
// var browserLanguage = navigator.language || navigator.userLanguage;
// // 取得した言語をコンソールに表示
// console.log('Browser Language:', browserLanguage);

// もし言語が英語かタガログ語であれば何か特定の処理を実行
// if (browserLanguage.startsWith('en')) {
//   // 英語の場合の処理
//   console.log('English Language Detected');
// } else if (browserLanguage.startsWith('tl')) {
//   // タガログ語の場合の処理
//   console.log('Tagalog Language Detected');
// } else {
//   // それ以外の言語の場合の処理
//   console.log('Other Language Detected');
// }







